import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-reset-confirmation-dialog',
  imports: [MatIconModule, MatDialogModule, MatButtonModule],
  templateUrl: './reset-confirmation-dialog.component.html',
  styleUrl: './reset-confirmation-dialog.component.scss',
})
export class ResetConfirmationDialogComponent {
  onClickReset() {
    location.reload();
  }
}
